import {
    GET_SUPPLIER_LIST_PROGRESS, GET_SUPPLIER_LIST_SUCCESS, GET_SUPPLIER_LIST_FAILURE,
    ADD_SUPPLIER_PROGRESS, ADD_SUPPLIER_SUCCESS, ADD_SUPPLIER_FAILURE,
    EDIT_DELETE_SUPPLIER_PROGRESS, EDIT_DELETE_SUPPLIER_SUCCESS, EDIT_DELETE_SUPPLIER_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    supplier: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const supplier_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUPPLIER_LIST_SUCCESS:
            return { ...state, supplier: action.supplier, loading: false };
        case GET_SUPPLIER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SUPPLIER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_SUPPLIER_PROGRESS:
            return { ...state, loading: true };
        case ADD_SUPPLIER_SUCCESS:
            return { ...state, supplier: [...state.supplier, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_SUPPLIER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to save the record, try again!' };
        case EDIT_DELETE_SUPPLIER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_SUPPLIER_SUCCESS:
            return {
                ...state,
                supplier: state.supplier.map((supplier) =>
                supplier._id === action.payload._id ? action.payload : supplier
                ),
                message: action.payload.is_deleted === 1 ? 'Record deleted successfully!' : 'Record updated successfully!'
            };
        case EDIT_DELETE_SUPPLIER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to update the record, try again!' };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default supplier_reducer;